import { useEffect, useState } from "react";
import { toast } from 'react-toastify';
import { useNavigate, useParams } from "react-router-dom";
import "../styles/MovieDetail.scss";
import axiosInstance from "../utils/axios";

const MovieDetail = () => {
  const [loading, setLoading] = useState(false);
  const [showTrailer, setShowTrailer] = useState(false);
  const navigate = useNavigate();
  const { slug } = useParams();
  const [movie, setMovie] = useState({});

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, []);


  const handleBookTickets = () => {

     navigate(`/book/${movie.slug}/${movie.id}`);

    // const section = document.getElementById("thirdpartytheaters");

    // if (section) {
    //   // console.log("Scrolling to third party theaters section");
    //   section.scrollIntoView({ behavior: "smooth" });
    // }
  };

  useEffect(() => {
    fetchDetail();
  }, []);

  const fetchDetail = async () => {
    if (!navigator.onLine) {
      console.error("Offline. Please check your connection and refresh.");
      setLoading(false);
      return;
    }
    setLoading(true);
    const timeoutPromise = new Promise((_, reject) => 
      setTimeout(() => reject(new Error('Load timeout')), 5000)
    );
    try {
      const res = await Promise.race([
        axiosInstance.get(`movie/movie/${slug}`),
        timeoutPromise
      ]);
      setMovie(res.data);
    } catch (err) {
      toast("Failed to load movie details. Please refresh.");
      console.log(err);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="movie-detail">
      {/* Banner Section */}
      <div
        className="movie-detail-banner-section"
        style={{ backgroundImage: `url(${movie.banner})` }}
      >
        <div className="banner-overlay">
          <div className="container">
            <div className="row align-items-center">

              <div className="col-md-3 text-center text-md-start">
                <img
                  src={movie.thumbnail}
                  alt="Poster"
                  className="img-fluid rounded shadow movie-poster"
                />
              </div>
              <div className="col-md-9 text-white text-center text-md-start mt-4 mt-md-0">
                <h2 className="mb-1">{movie.name}</h2>
                <p>
                  {movie.display_language} ‧ {movie?.display_genre?.join("/")} ‧ {movie.duration}
                </p>
                <div className="mb-2 d-flex gap-2 flex-wrap justify-content-center justify-content-md-start">
                  {movie?.display_genre?.map((g, idx) => (
                    <span key={idx} className="badge bg-secondary text-white">
                      {g}
                    </span>
                  ))}
                </div>
                <p>{movie.about}</p>

                <div className="rating mb-3">
                  <strong>Directed By: {movie.directed_by}</strong>
                </div>

                <div className="mb-4 d-flex gap-3 flex-wrap justify-content-center justify-content-md-start">
                  <button
                    className="btn btn-danger"
                    onClick={() => setShowTrailer(true)}
                  >
                    ▶ Watch Trailer
                  </button>
                  <button
                    className="btn btn-outline-light"
                    onClick={handleBookTickets}
                  >
                    🎟 Book Tickets
                  </button>
                </div>

                {/* Cast & Crew */}
                <div className="rating">
                  <strong>Cast & Crews</strong>
                </div>
                <ol className="cast-list text-start px-3 px-md-0 mt-0">
                  {movie.starring?.split(",").map((actor, i) => (
                    <li key={i} style={{ marginLeft: "20px", color: "orange" }}>
                      {actor.trim()},
                    </li>
                  ))}
                </ol>

                <div className="rating">
                  <strong>Music By</strong>
                </div>
                <ol className="cast-list text-start px-3 px-md-0 mt-0">
                  {movie.music_by?.split(",").map((actor, i) => (
                    <li key={i} style={{ marginLeft: "20px", color: "orange" }}>
                      {actor.trim()},
                    </li>
                  ))}
                </ol>
              </div>
            </div>
          </div>
        </div>

      </div>



      {/* Trailer Modal */}
      {showTrailer && (
        <div className="video-modal" onClick={() => setShowTrailer(false)}>
          <div className="video-wrapper" onClick={(e) => e.stopPropagation()}>
            <iframe
              width="100%"
              height="400"
              src={movie.trailer}
              title="Trailer"
              frameBorder="0"
              allow="autoplay; encrypted-media"
              allowFullScreen
            />
            <video
              width="100%"
              height="400"
              controls
              autoPlay
            >
              <source src={movie.trailer} type="video/mp4" />
              Your browser does not support the video tag.
            </video>

            <button className="btn-close" onClick={() => setShowTrailer(false)}>
              ×
            </button>
          </div>
        </div>
      )}

    </div>
  );
};

export default MovieDetail;
